module.exports = __webpack_public_path__ + "static/media/  (105).0940d4fe.jpg";